'use client';

import React, { useCallback, useState, useEffect } from 'react';
import { Solicitud } from '@/types/solicitud';
import SolicitudManagement from './SolicitudManagement';
import { solicitudService } from '@/lib/api/solicitudService';
import { getCurrentUser } from '@/services/authService';
import ErrorMessage from '@/components/common/ErrorMessage';

/**
 * Módulo Pre Análisis:
 * - estatus = "ENTREGA A RIESGOS"
 * - fechaPrimerSolicitudVoBo == "" (sin VoBo)
 * - fechaRevisionDocumentalConcluida != "" (revisión documental completada)
 * - fechaAnalisisConluido == "" (análisis no completado)
 */
const PreAnalisisManagement: React.FC = () => {
  const [initialSolicitudes, setInitialSolicitudes] = useState<Solicitud[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchPreAnalisis = useCallback(async () => {
    setLoading(true);
    setError(null);
    const currentUser = getCurrentUser();
    if (!currentUser || !currentUser.ownerID) {
      setError("No se pudo obtener el ID del usuario actual.");
      setLoading(false);
      return;
    }
    try {
      const response = await solicitudService.getPreAnalisis(currentUser.ownerID);
      if (response.data) {
        setInitialSolicitudes(response.data);
      } else {
        setError(response.error || "Error al cargar solicitudes de Pre Análisis.");
      }
    } catch (err: any) {
      setError(err.message || "Error de red al cargar solicitudes.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchPreAnalisis();
  }, [fetchPreAnalisis]);

  if (loading) {
    return <div className="text-center py-4">Cargando solicitudes...</div>;
  }

  if (error) {
    return <ErrorMessage message={error} />;
  }

  return (
    <SolicitudManagement
      fixedStatus="ENTREGA A RIESGOS"
      title="Pre Análisis"
      modulo="pre-analisis"
      initialSolicitudes={initialSolicitudes}
      customFetch={fetchPreAnalisis}
      showNewButton={false}
    />
  );
};

export default PreAnalisisManagement;
